import { usersCollection } from '../../config/firebase';

let state = {
	musicReferences: [],
	loading: false,
	notification: { message: '', type: '' },
};
let getters = {
	musicReferences: state => state.musicReferences,
	musicReferenceLoading: state => state.loading,
	musicReferenceNotification: state => state.notification,
};
let actions = {
	async getMusicReferences({ commit }, payload) {
		
		commit('setMusicReferenceLoading', true);
		usersCollection
			.doc(payload)
			.onSnapshot(async snapshot => {
				let { streaming_links } = snapshot.data();
				
				streaming_links = streaming_links ? streaming_links : [];
				commit('setMusicReferencesData', streaming_links);
				commit('setMusicReferenceLoading', false);
			});
	},
	async addMusicReference({ commit }, payload) {
		commit('setMusicReferenceLoading', true);
		let id = payload.id;
		delete payload.id;
		try {
			usersCollection
				.doc(id)
				.get()
				.then(async snapshot => {
					let data = snapshot.data();
					let { streaming_links } = data;
					streaming_links = streaming_links ? streaming_links : [];

					streaming_links.push({ ...payload });
					data['streaming_links'] = streaming_links;
					await usersCollection.doc(id).update({ ...data });
				});
			commit('setMusicReferencesNotification', {
				message: 'Streaming Links Added',
				type: 'success',
			});
		} catch (err) {
			
			commit('setMusicReferencesNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setMusicReferenceLoading', false);
		}
	},
	async editMusicReference({ commit }, payload) {
		commit('setMusicReferenceLoading', true);
		let id = payload.id;
		delete payload.id;
		try {
			usersCollection
				.doc(id)
				.get()
				.then(async snapshot => {
					let {idx} = payload;
					delete payload.idx;
					let data = snapshot.data();
					let { streaming_links } = data;
					streaming_links[idx] = { ...payload };
					data['streaming_links'] = streaming_links;
					await usersCollection.doc(id).update({ ...data });
				});
			commit('setMusicReferencesNotification', {
				message: 'Streaming Links Updated',
				type: 'success',
			});
		} catch (err) {
			
			commit('setMusicReferencesNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setMusicReferenceLoading', false);
		}
	},
	async deleteMusicReference({ commit }, payload) {
		commit('setMusicReferenceLoading', true);
		let id = payload.id;
		delete payload.id;
		try {
			usersCollection
				.doc(id)
				.get()
				.then(async snapshot => {
					let idx = payload.idx;
					delete payload.idx;
					let data = snapshot.data();
					let { streaming_links } = data;
					streaming_links = streaming_links.filter(
						(music_reference, index) => idx != index
					);
					data['streaming_links'] = streaming_links;
					await usersCollection.doc(id).update({ ...data });
				});
			commit('setMusicReferencesNotification', {
				message: 'Streaming Links Deleted',
				type: 'success',
			});
		} catch (err) {
			
			commit('setMusicReferencesNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setMusicReferenceLoading', false);
		}
	},
};
let mutations = {
	setMusicReferencesData(state, payload) {
		state.musicReferences = payload;
	},
	setMusicReferenceLoading(state, payload) {
		state.loading = payload;
	},
	setMusicReferencesNotification(state, payload) {
		let { notification } = state;
		notification.message = payload.message;
		notification.type = payload.type;
		state.notification = notification;
		window.setTimeout(() => {
			let obj = { message: '', type: '' };
			state.notification = obj;
		}, 5000);
	},
};
export default { state, getters, actions, mutations };
